/**
 * Este enum define os nomes de tabelas que o backend espera,
 * todos em maiúsculo e exatamente iguais aos nomes no banco.
 */
export enum TableNameEnum {
    NONE = 'NONE',
    ADDRESS = 'ADDRESS',
    CLIENT = 'CLIENT',
    COMPANY = 'COMPANY',
    DEVICE = 'DEVICE',
    HISTORIC = 'HISTORIC',
    PHONE = 'PHONE',
    PRODUCT = 'PRODUCT',
    PROFILE = 'PROFILE',
    SALE = 'SALE',
    SALE_ITEM = 'SALE_ITEM',
    SERVICE_PERFORMED = 'SERVICE_PERFORMED',
    USER = 'USER',
    WORK_ORDER = 'WORK_ORDER',
    WORK_ORDER_DEVICE = 'WORK_ORDER_DEVICE',
    WORK_ORDER_DEVICE_PRODUCTS = 'WORK_ORDER_DEVICE_PRODUCTS',
    WORK_ORDER_DEVICE_SERVICES = 'WORK_ORDER_DEVICE_SERVICES',
    SCHEDULING = 'SCHEDULING',
    PENDING = 'PENDING',
    PARAMETRIZATION = 'PARAMETRIZATION',
    TOOLS = 'TOOLS',
    MOVIMENT = 'MOVIMENT',
    TOOLS_MOVIMENT = 'TOOLS_MOVIMENT',
    PRODUCT_MOVIMENT = 'PRODUCT_MOVIMENT',
    TICKET = 'TICKET',
    SUBSCRIPTION = 'SUBSCRIPTION', // Assinatura
}

/**
 * Enum em português para exibir em grids e selects.
 */
export enum TableNameEnumBr {
    NONE = 'Nenhum',
    ADDRESS = 'Endereço',
    CLIENT = 'Cliente',
    COMPANY = 'Empresa',
    DEVICE = 'Dispositivo',
    HISTORIC = 'Histórico',
    PHONE = 'Telefone',
    PRODUCT = 'Produto',
    PROFILE = 'Perfil',
    SALE = 'Venda',
    SALE_ITEM = 'Item de Venda',
    SERVICE_PERFORMED = 'Serviço Realizado',
    USER = 'Usuário',
    WORK_ORDER = 'Ordem de Serviço',
    WORK_ORDER_DEVICE = 'Dispositivo da OS',
    WORK_ORDER_DEVICE_PRODUCTS = 'Produtos da OS',
    WORK_ORDER_DEVICE_SERVICES = 'Serviços da OS',
    SCHEDULING = 'Agendamento',
    PENDING = 'Pendente',
    PARAMETRIZATION = 'Parametrização',
    TOOLS = 'Ferramenta',
    MOVIMENT = 'Movimentação',
    TOOLS_MOVIMENT = 'Movimentação de Ferramentas',
    PRODUCT_MOVIMENT = 'Movimentação de Produtos',
    TICKET = 'Ticket',
    SUBSCRIPTION = 'Assinatura', // Assinatura
}

/**
 * Mapeia cada valor do enum para o texto exibido no frontend.
 * Ex.: "USER" -> "Usuário"
 */
export const TableNameEnumLabel: Record<TableNameEnum, string> = {
    [TableNameEnum.NONE]: 'Nenhum',
    [TableNameEnum.ADDRESS]: 'Endereço',
    [TableNameEnum.CLIENT]: 'Cliente',
    [TableNameEnum.COMPANY]: 'Empresa',
    [TableNameEnum.DEVICE]: 'Dispositivo',
    [TableNameEnum.HISTORIC]: 'Histórico',
    [TableNameEnum.PHONE]: 'Telefone',
    [TableNameEnum.PRODUCT]: 'Produto',
    [TableNameEnum.PROFILE]: 'Perfil',
    [TableNameEnum.SALE]: 'Venda',
    [TableNameEnum.SALE_ITEM]: 'Item de Venda',
    [TableNameEnum.SERVICE_PERFORMED]: 'Serviço Realizado',
    [TableNameEnum.USER]: 'Usuário',
    [TableNameEnum.WORK_ORDER]: 'Ordem de Serviço',
    [TableNameEnum.WORK_ORDER_DEVICE]: 'Dispositivo da OS',
    [TableNameEnum.WORK_ORDER_DEVICE_PRODUCTS]: 'Produtos da OS',
    [TableNameEnum.WORK_ORDER_DEVICE_SERVICES]: 'Serviços da OS',
    [TableNameEnum.SCHEDULING]: 'Agendamento',
    [TableNameEnum.PENDING]: 'Pendente',
    [TableNameEnum.PARAMETRIZATION]: 'Parametrização',
    [TableNameEnum.TOOLS]: 'Ferramenta',
    [TableNameEnum.MOVIMENT]: 'Movimentação',
    [TableNameEnum.TOOLS_MOVIMENT]: 'Movimentação de Ferramentas',
    [TableNameEnum.PRODUCT_MOVIMENT]: 'Movimentação de Produtos',
    [TableNameEnum.TICKET]: 'Ticket',
    [TableNameEnum.SUBSCRIPTION]: 'Assinatura', // Assinatura

};

/**
 * Mapeia cada valor do enum para uma cor padrão para exibição em badges no frontend.
 */
export const TableNameEnumColor: Record<TableNameEnum, string> = {
    [TableNameEnum.NONE]: '#808080', // cinza
    [TableNameEnum.ADDRESS]: '#6495ED',
    [TableNameEnum.CLIENT]: '#1E90FF',
    [TableNameEnum.COMPANY]: '#4682B4',
    [TableNameEnum.DEVICE]: '#9370DB',
    [TableNameEnum.HISTORIC]: '#8B4513',
    [TableNameEnum.PHONE]: '#00CED1',
    [TableNameEnum.PRODUCT]: '#2E8B57',
    [TableNameEnum.PROFILE]: '#FFD700',
    [TableNameEnum.SALE]: '#FF8C00',
    [TableNameEnum.SALE_ITEM]: '#FFA07A',
    [TableNameEnum.SERVICE_PERFORMED]: '#DC143C',
    [TableNameEnum.USER]: '#20B2AA',
    [TableNameEnum.WORK_ORDER]: '#FF1493',
    [TableNameEnum.WORK_ORDER_DEVICE]: '#DB7093',
    [TableNameEnum.WORK_ORDER_DEVICE_PRODUCTS]: '#FF4500',
    [TableNameEnum.WORK_ORDER_DEVICE_SERVICES]: '#FF6347',
    [TableNameEnum.SCHEDULING]: '#ADFF2F',
    [TableNameEnum.PENDING]: '#FF0000',
    [TableNameEnum.PARAMETRIZATION]: '#00BFFF',
    [TableNameEnum.TOOLS]: '#6A5ACD',
    [TableNameEnum.MOVIMENT]: '#7B68EE',
    [TableNameEnum.TOOLS_MOVIMENT]: '#4169E1',
    [TableNameEnum.PRODUCT_MOVIMENT]: '#3CB371',
    [TableNameEnum.TICKET]: '#FF69B4',
    [TableNameEnum.SUBSCRIPTION]: '#FFB6C1', // Assinatura
};
